import { render } from "./KidHeader2.vue?vue&type=template&id=6a3975d8&scoped=true"
import script from "./KidHeader2.vue?vue&type=script&lang=js"
export * from "./KidHeader2.vue?vue&type=script&lang=js"

import "./KidHeader2.vue?vue&type=style&index=0&id=6a3975d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3975d8"]])

export default __exports__